export const TABLE_CHECKBOX_PATHS = {
  outline:
    'M5.30775 20.5C4.80258 20.5 4.375 20.325 4.025 19.975C3.675 19.625 3.5 19.1974 3.5 18.6923V5.30775C3.5 4.80258 3.675 4.375 4.025 4.025C4.375 3.675 4.80258 3.5 5.30775 3.5H18.6923C19.1974 3.5 19.625 3.675 19.975 4.025C20.325 4.375 20.5 4.80258 20.5 5.30775V18.6923C20.5 19.1974 20.325 19.625 19.975 19.975C19.625 20.325 19.1974 20.5 18.6923 20.5H5.30775ZM5.30775 19H18.6923C18.7693 19 18.8398 18.9679 18.9038 18.9038C18.9679 18.8398 19 18.7693 19 18.6923V5.30775C19 5.23075 18.9679 5.16025 18.9038 5.09625C18.8398 5.03208 18.7693 5 18.6923 5H5.30775C5.23075 5 5.16025 5.03208 5.09625 5.09625C5.03208 5.16025 5 5.23075 5 5.30775V18.6923C5 18.7693 5.03208 18.8398 5.09625 18.9038C5.16025 18.9679 5.23075 19 5.30775 19Z',
  filled:
    'M5 21C4.45 21 3.97917 20.8042 3.5875 20.4125C3.19583 20.0208 3 19.55 3 19V5C3 4.45 3.19583 3.97917 3.5875 3.5875C3.97917 3.19583 4.45 3 5 3H19C19.55 3 20.0208 3.19583 20.4125 3.5875C20.8042 3.97917 21 4.45 21 5V19C21 19.55 20.8042 20.0208 20.4125 20.4125C20.0208 20.8042 19.55 21 19 21H5Z',
  check:
    'M10.6 13.4L8.45 11.25C8.26667 11.0667 8.03333 10.975 7.75 10.975C7.46667 10.975 7.23333 11.0667 7.05 11.25C6.86667 11.4333 6.775 11.6667 6.775 11.95C6.775 12.2333 6.86667 12.4667 7.05 12.65L9.9 15.5C10.1 15.7 10.3333 15.8 10.6 15.8C10.8667 15.8 11.1 15.7 11.3 15.5L16.95 9.85C17.1333 9.66667 17.225 9.43333 17.225 9.15C17.225 8.86667 17.1333 8.63333 16.95 8.45C16.7667 8.26667 16.5333 8.175 16.25 8.175C15.9667 8.175 15.7333 8.26667 15.55 8.45L10.6 13.4Z',
  indeterminate:
    'M8 13H16C16.2833 13 16.5208 12.9042 16.7125 12.7125C16.9042 12.5208 17 12.2833 17 12C17 11.7167 16.9042 11.4792 16.7125 11.2875C16.5208 11.0958 16.2833 11 16 11H8C7.71667 11 7.47917 11.0958 7.2875 11.2875C7.09583 11.4792 7 11.7167 7 12C7 12.2833 7.09583 12.5208 7.2875 12.7125C7.47917 12.9042 7.71667 13 8 13Z'
} as const

export function TableCheckboxIcons() {
  return (
    <>
      <svg
        data-slot='checkbox-icon'
        data-state='unchecked'
        viewBox='0 0 24 24'
        fill='none'
        aria-hidden='true'
        focusable='false'
        className='size-6 group-data-[checked]:hidden group-data-[indeterminate]:hidden'
      >
        <path d={TABLE_CHECKBOX_PATHS.outline} fill='currentColor' />
      </svg>
      <svg
        data-slot='checkbox-icon'
        data-state='checked'
        viewBox='0 0 24 24'
        fill='none'
        aria-hidden='true'
        focusable='false'
        className='hidden size-6 group-data-[checked]:block group-data-[indeterminate]:hidden'
      >
        <path
          d={`${TABLE_CHECKBOX_PATHS.check}${TABLE_CHECKBOX_PATHS.filled}`}
          fill='currentColor'
        />
      </svg>
      <svg
        data-slot='checkbox-icon'
        data-state='indeterminate'
        viewBox='0 0 24 24'
        fill='none'
        aria-hidden='true'
        focusable='false'
        className='hidden size-6 group-data-[indeterminate]:block'
      >
        <path
          d={`${TABLE_CHECKBOX_PATHS.indeterminate}${TABLE_CHECKBOX_PATHS.filled}`}
          fill='currentColor'
        />
      </svg>
    </>
  )
}
